<template>
  <div id="percentageChart">
    <PieChart :chartData="chartData" :title="'2018 Expenses'"/>
  </div>
</template>
<script>
import PieChart from './PieChart'
export default {
  data() {
    return {
      chartData: {
        labels: ['Cost of real estate sold', 'Salaries and Wages', 'Payroll taxes and employee benefits', 'Professional fees', 'Conferences and meetings', 'Office expenses', 'Advertising', 'Miscellaneous'],
        datasets: [
          {
            label: '$',
            backgroundColor: ['hsl(163, 40%, 70%)', 'hsl(207, 47%, 65%)', 'hsl(11, 71%, 60%)', 'hsl(39, 100%, 70%)', 'hsl(23, 81%, 60%)', 'hsl(274, 36%, 70%)', '#333', 'eee'],
            data: [1107190, 109282, 19167, 31861, 7915, 3794, 6063, 9341]
          }
        ]
      }
    }
  },
  components: { PieChart }
}
</script>



// WEBPACK FOOTER //
// src/components/FinancialsPie.vue